/** 
* 图片相册功能
* 作者：黄璞
* 时间：2020-07-23
* @param {string} container
* @param {string} imgContent
* @param {string} imgAuthor
**/

var hs = hs || {};

hs.ImgAlbum = function (param) {
  // 入口
  this.container = param.container || '[data-album="container"]';
  // 图片标签
  this.imgContent = param.imgcontent || '[data-album="img"]'
  // 图片名称
  this.imgName = param.imgName || '[data-album="name"]'
  // 作者信息标签
  this.imgAuthor = param.imgAuthor || '[data-album="author"]'
  // 自定义className
  this.classSkin = param.classSkin || ''
  // 容器结构
  this.containerHtml = document.querySelector(this.container)
  // 获取页面内容结构
  this.elementHtml = this.containerHtml.getElementsByTagName('img')

  // 相册结构
  this.albumContainer = document.createElement('div')
  this.albumContainer.className = 'album-wrapper'
  this.albumContainer.innerHTML =
    '<div class="album-container' + this.classSkin + '">' +
    ' <div class="album-content"></div>' +
    '</div>' +
    '<div class="album-mask"></div>'
}

// 初始化
hs.ImgAlbum.prototype.init = function () {
  // 插入相册外层容器结构
  document.querySelector('body').appendChild(this.albumContainer)
  document.querySelector('body').setAttribute('style', 'overflow-x:hidden;overflow-y:hidden;')
  document.querySelector('.album-wrapper').setAttribute('style', 'width:' + window.innerWidth + 'px;' + 'height: ' + window.innerHeight + 'px;')

  // 页面图片数据
  var _imgArryVal = this.ImgArry();
  console.log(_imgArryVal)
  this.append(_imgArryVal);
}

// 添加虚拟DOm相册
hs.ImgAlbum.prototype.append = function (photos) {
  photos.forEach((function (photo) {
    var item = document.createElement('div')
    item.className = 'album-item'
    item.innerHTML =
      '<div class="album-photo">' +
      '<img class="album-image" src="' + photo.imgUrl + '">' +
      '</div>' +
      '<div class="album-photo-info">' +
      '<div class="name">' + photo.name + '</div>' +
      '<div class="author">' + photo.author + '</div>' +
      '</div>'
    // 插入到相册容器中
    document.querySelector('.album-content').appendChild(item)
    var $img = item.querySelector('img');
    $img.onload = function (params) {
      var infoHtml = document.querySelector('.album-photo-info').clientHeight;
      document.querySelector('.album-container').setAttribute('style',
        'width:' + parseInt($img.naturalWidth) + 'px;' +
        'height: ' + parseInt($img.naturalHeight + infoHtml) + 'px;' +
        'position:' + 'absolute;' +
        'top:' + '50%;' +
        'left:' + '50%;' +
        'margin-top:-' + parseInt($img.naturalWidth) / 2 + 'px;' +
        'margin-left:-' + parseInt($img.naturalHeight + infoHtml) / 2 + 'px;'
      )
      document.querySelector('.album-content').setAttribute('style',
        'transition: all 0ms ease 0s;' +
        'transform: translate3d(-' + window.innerHeight + 'px, 0px, 0px)'
      )
      // 图片宽高
      item.style.width = parseInt($img.naturalWidth) + 'px'
      item.querySelector('.album-photo').style.width = parseInt($img.naturalWidth) + 'px'
      item.querySelector('.album-photo').style.height = parseInt($img.naturalHeight) + 'px'
    }


  }).bind(this))
}

// 根据图片标签 获取页面图片数据
hs.ImgAlbum.prototype.ImgArry = function () {
  var imgArry = [];

  for (var i = 0; i < this.elementHtml.length; i++) {
    var elementImg = this.elementHtml[i];
    var elementAuthor = this.containerHtml.children[i];
    //作者信息
    var eleText = elementAuthor.querySelector(this.imgAuthor).innerText
    //图片名称
    var eleName = elementAuthor.querySelector(this.imgName).innerText
    // 重组数组
    imgArry.push({ 'author': eleText, 'imgUrl': elementImg.src, 'name': eleName })
  }
  return imgArry
}

